module.exports = __webpack_public_path__ + "4-lined-c6996e9faa3e5b4a6ba158130ca5056a.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/lined/4-lined.svg
// module id = 133
// module chunks = 0